import { fieldsToSplitByLocality } from "./Constants"

export function getSpotsString(n_spots) {
    return n_spots === 1 ?
        "vaga"
        :
        "vagas"
}

export function splitFieldByLocalities(selectedField) {
    return fieldsToSplitByLocality.includes(selectedField);
}

export let nSpotsPerLocality = {}

export var redirectToHome = () => (window.location.href = "/");

